
import { mapState } from 'vuex';

export default {
  name: 'AppManagerReviewContent',
  computed: {
    ...mapState('widget', ['brandName']),
    ...mapState('reviewSettings', ['reviewSettings'])
  }
};
